import { CommonModule } from '@angular/common';
import { HttpResponse } from '@angular/common/http';
import { Component, OnDestroy } from '@angular/core';
import { FormControl, FormGroup, ReactiveFormsModule, Validators } from '@angular/forms';
import { Router } from '@angular/router';
import { PageUrls } from '@constants/page-urls.constants';
import { NgbNavModule } from '@ng-bootstrap/ng-bootstrap';
import { AuthenticationService } from '@services/authentication/authentication.service';
import { OrchestratorService } from '@services/orchestrator/orchestrator.service';
import { SessionService } from '@services/session/session.service';
import { ThemeService } from '@services/theme/theme.service';
import { ValidateFields } from '@shared/models/shopping.model';
import { Subscription } from 'rxjs';

@Component({
  selector: 'ts-login-as-anyone',
  templateUrl: './login-as-anyone.component.html',
  styleUrls: ['./login-as-anyone.component.scss'],
  imports: [CommonModule, ReactiveFormsModule, NgbNavModule]
})
export class LoginAsAnyoneComponent implements OnDestroy {
  form: FormGroup;
  login_btn_disabled: boolean = false;
  login_error: boolean = false;
  current_tab: number = 1;
  private subscriptions: Subscription = new Subscription();

  constructor(
    private auth_svc: AuthenticationService,
    private orchestrator_svc: OrchestratorService,
    private router: Router,
    private session_svc: SessionService,
    public theme_svc: ThemeService
  ) {
    this.createForm();
  }

  ngOnDestroy(): void {
    this.subscriptions.unsubscribe();
  }

  onRegisterSubmit(): void {
    this.login_btn_disabled = true;

    this.subscriptions.add(
      this.orchestrator_svc
        .authenticate(
          this.form.get('email')?.value,
          this.form.get('clientCustomCode')?.value,
          this.form.get('masqEmail')?.value,
          this.form.get('masqClientCustomCode')?.value
        )
        .subscribe({
          next: (res: boolean) => {
            this.login_btn_disabled = false;
            if (res) {
              this.login_error = false;
              this.router.navigate([PageUrls.HOME]);
            } else this.login_error = true;
          },
          error: (err) => {}
        })
    );
  }

  validateDirectLogin(): void {
    this.subscriptions.add(
      this.auth_svc.validateDirectLogin().subscribe({
        next: (res: HttpResponse<ValidateFields>) => {
          if (res.body?.valid) {
            this.login_error = false;
            this.onRegisterSubmit();
          } else this.login_error = true;
        },
        error: (err) => {}
      })
    );
  }

  checkLoginStatus(): boolean {
    return !this.session_svc.hasUser();
  }

  toggleForm(index: number): void {
    this.form.reset();
    this.login_error = false;
    if (index === 2) {
      this.form.controls['masqEmail'].addValidators([Validators.required, Validators.email]);
      this.form.controls['masqClientCustomCode'].addValidators([Validators.required]);
    } else {
      this.form.controls['masqEmail'].clearValidators();
      this.form.controls['masqClientCustomCode'].clearValidators();
    }
    this.form.controls['masqEmail'].updateValueAndValidity();
    this.form.controls['masqClientCustomCode'].updateValueAndValidity();
  }

  protected readonly onsubmit = onsubmit;

  private createForm() {
    this.form = new FormGroup({
      email: new FormControl(null, [Validators.required, Validators.email]),
      clientCustomCode: new FormControl(null, [Validators.required]),
      masqEmail: new FormControl(null),
      masqClientCustomCode: new FormControl(null)
    });
  }
}
